import firebase from 'firebase'
import axios from 'axios'
import VueAxios from 'vue-axios'



export default {
    state: {     
    isSyncedProducts:false, 
    products:null
    },
    mutations: {
        resetProductCategory (state, payload) {          
            if(state.products===null){
                state.products= new Object()
            }
            state.products[payload.category] = []
        },
        setProducts (state, payload) {          
            if(state.products===null){
                state.products= new Object()
            }
            if(state.products[payload.category]===undefined || state.products[payload.category]===null ){
                state.products[payload.category]= [] 
            }
            state.products[payload.category] = payload.products
        },           
        addProduct (state, payload) {          
            if(state.products===null){
                state.products= new Object()
            }
            if(state.products[payload.category]===undefined || state.products[payload.category]===null ){
                state.products[payload.category]= [] 
            }
            state.products[payload.category].push(payload.product)
        },        
        resetProductsState(state, payload){
            state.isSyncedProducts=false
            state.products=null
        },
        setIsSyncedProducts(state, payload){
            state.isSyncedProducts = payload
        }                             
    },
    actions: {
        clearError ({commit}) {
            commit('clearError')
        },
        initProductsSynch({commit}, payload) {
            console.log('inside initProductsSynch')
            commit('setIsSyncedProducts', false) 
            var productFunctionUrl = "https://us-central1-zzques-2e9f8.cloudfunctions.net/getProducts"
            if(process.env.NODE_ENV==='development' || process.env.NODE_ENV==='staging'){
                productFunctionUrl = "https://us-central1-zzques-staging.cloudfunctions.net/getProducts"
            }
            var campaignid = '5338416555'
            var appid = 'RodneyCe-MyQuePsi-PRD-27f3df848-bbc6711a'

            var myProducts = {
                accessories:[
                    {isactive:true, platform: 'ebay', itemid: '292659077089'},
                    {isactive:true, platform: 'ebay', itemid: '273514718493'},
                    {isactive:true, platform: 'ebay', itemid: '352194471575'},

                    {isactive:true, platform: 'ebay', itemid: '362353656407'},
                    {isactive:true, platform: 'ebay', itemid: '362443545755'},
                    {isactive:true, platform: 'ebay', itemid: '232136987565'},
                    {isactive:true, platform: 'ebay', itemid: '192675591523'},
                    {isactive:true, platform: 'ebay', itemid: '362443540950'},
                    {isactive:true, platform: 'ebay', itemid: '362443540660'},
                    
                    {isactive:true, platform: 'ebay', itemid: '301907193672'},
                    {isactive:true, platform: 'ebay', itemid: '362103120302'}
                    
                    
                    
                    
                    
                    
                ],
                clothing:[
                    {isactive:true, platform: 'ebay', itemid: '142170918341'},
                    {isactive:true, platform: 'ebay', itemid: '132019121737'},
                    {isactive:true, platform: 'ebay', itemid: '112218333685'},
                    
                    
                    {isactive:true, platform: 'ebay', itemid: '252988264809'},
                    {isactive:true, platform: 'ebay', itemid: '153031399560'},
                    {isactive:true, platform: 'ebay', itemid: '252987731718'},
                    {isactive:true, platform: 'ebay', itemid: '362452735691'},
                    {isactive:true, platform: 'ebay', itemid: '362452735464'},
                    {isactive:true, platform: 'ebay', itemid: '253148200588'},
                    {isactive:true, platform: 'ebay', itemid: '362409312631'}
                    
                    
                    
                    
                    

                    
                    
                ],
                general:[
                    {isactive:true, platform: 'ebay', itemid: '163112289994'},
                    {isactive:true, platform: 'ebay', itemid: '362354380898'},
                    {isactive:true, platform: 'ebay', itemid: '250980662927'},
                    {isactive:true, platform: 'ebay', itemid: '292644938389'},
                    {isactive:true, platform: 'ebay', itemid: '362307199326'},
                    {isactive:true, platform: 'ebay', itemid: '292106351188'}

                ],

            }
            var promises = []
            Object.keys(myProducts).forEach(category=>{
                var categoryproducts = myProducts[category]
                commit('resetProductCategory', {category: category}) 

                if(categoryproducts && categoryproducts.length>0){                    
                    axios.defaults.headers.get['crossDomain'] = true;
                    var promise = axios
                    .post(productFunctionUrl, categoryproducts)
                    .then(r => r.data)
                    .then(rspProducts => {
                        console.log(rspProducts)
                        commit('setProducts', {category: category, products: rspProducts}) 
                    })
                    promises.push(promise)
                }
            })
            return Promise.all(promises).then(()=>{
                commit('setIsSyncedProducts', true)       
            })
            /*
            var myProducts = new Object ()
            myProducts.accessories = new Array()
            myProducts.accessories.push({isactive:true, platform: 'ebay', itemid: '292659077089'})

            var categories = Object.keys(myProducts)
            categories.forEach(category=>{
                var categoryProducts = myProducts[category]
                if(categoryProducts && categoryProducts.length>0){
                    categoryProducts.forEach(p=>{
                        if(p.isactive && p.platform==='ebay'){
                            var itemid = p.itemid
                            axios.defaults.headers.get['crossDomain'] = true;
                            axios
                            .get(`http://open.api.ebay.com/shopping?callname=GetSingleItem&responseencoding=JSON&appid=${appid}&siteid=0&version=967&trackingid=${campaignid}&trackingpartnercode=9&ItemID=${itemid}`)
                            .then(r => r.data)
                            .then(ebayproducts => {
                            console.log(ebayproducts)
                            })

                        }else if(p.isactive && p.platform==='etsy'){

                        }

                    })
                }
            })
            */
        }       
    },
    getters: {
        products (state){
            return state.products
        },            
        isSyncedProducts(state){
            return state.products
        }                               
    }
  }